import { jsx as _jsx } from "react/jsx-runtime";
import SelectedFilterWrapper from "@/components/Categories/Menu/SelectedFilter";
import { SOLVOOKPASS_TEXT } from "@/settings/constant";
import React from "react";
import { SearchQueryKey } from "src/api/search";
export const SearchFilterSelectedList = (param)=>{
    let { selectedFilterList , handleResetFilter , handleDetailFilter , handleSolvookPassesFilter , hasSelectedFilter , position  } = param;
    if (hasSelectedFilter) return /*#__PURE__*/ _jsx(SelectedFilterWrapper, {
        className: "search-page",
        position: position,
        button: /*#__PURE__*/ _jsx(SelectedFilterWrapper.ResetButton, {
            handleResetFilter: handleResetFilter
        }),
        children: selectedFilterList.map((item, idx)=>{
            if (item.key === SearchQueryKey.SOLVOOKPASSES && (item === null || item === void 0 ? void 0 : item.label) === SOLVOOKPASS_TEXT) {
                return /*#__PURE__*/ _jsx(SelectedFilterWrapper.SelectedItem, {
                    label: SOLVOOKPASS_TEXT,
                    onRemove: ()=>handleSolvookPassesFilter(item.value)
                }, "selectedItem" + idx);
            }
            return /*#__PURE__*/ _jsx(SelectedFilterWrapper.SelectedItem, {
                label: item.label || item.value,
                onRemove: ()=>handleDetailFilter(item.key, item.value)
            }, "selectedItem" + idx);
        })
    });
};
